import { createOptionsSelector } from '@mews-commander/utils';
import { getTimeZones as getTimeZonesSelector } from '@mews-commander/core/legacy-globalization';

export const getTimeZoneOptions = createOptionsSelector(getTimeZonesSelector, { value: 'code', label: 'englishName' });
